import { useMemo } from 'react';
import { useAuth, hasSuperAdminAccess } from '../../contexts/AuthContext';

export type AdminSection =
  | 'user-management'
  | 'corporate-user-management'
  | 'listing-management'
  | 'reel-management'
  | 'data-management'
  | 'support-tickets'
  | 'moderation'
  | 'utm-kaynaklari';

export type AdminMenuItem = {
  key: AdminSection | 'admin-logs';
  path: string;
  label: string;
  icon: string;
};

export const baseAdminMenuItems: AdminMenuItem[] = [
  { key: 'user-management', path: '/admin-panel/user-management', label: 'Kullanıcı Yönetimi', icon: 'fa-users' },
  {
    key: 'corporate-user-management',
    path: '/admin-panel/corporate-user-management',
    label: 'Kurumsal Kullanıcı Yönetimi',
    icon: 'fa-building',
  },
  { key: 'listing-management', path: '/admin-panel/listing-management', label: 'İlan Yönetimi', icon: 'fa-list' },
  { key: 'reel-management', path: '/admin-panel/reel-management', label: 'Gönderi Yönetimi', icon: 'fa-video' },
  { key: 'data-management', path: '/admin-panel/data-management', label: 'Veri Yönetimi', icon: 'fa-database' },
  { key: 'support-tickets', path: '/admin-panel/support-tickets', label: 'Destek Talepleri', icon: 'fa-headset' },
  { key: 'moderation', path: '/admin-panel/moderation', label: 'Moderasyon', icon: 'fa-shield-alt' },
  { key: 'utm-kaynaklari', path: '/admin-panel/utm-kaynaklari', label: 'UTM Kaynakları', icon: 'fa-chart-line' },
];

export const superAdminMenuItem: AdminMenuItem = {
  key: 'admin-logs',
  path: '/admin-panel/admin-logs',
  label: 'Yönetici Logları',
  icon: 'fa-clipboard-list',
};

export function useAdminMenuItems(): AdminMenuItem[] {
  const { user } = useAuth();

  return useMemo(() => {
    if (hasSuperAdminAccess(user)) {
      return [...baseAdminMenuItems, superAdminMenuItem];
    }
    return baseAdminMenuItems;
  }, [user]);
}
